import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import ApiContext from '@/contexts/ApiContext';
import classes from '@/orderForm/OrderForm/OrderFormPage/OrderFormPageFooter.module.css';

const Spinner = () => (
  <span className={classes.Spinner}>
    <svg className="animate-spin h-full w-full text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  </span>
);

const OrderFormPageFooter = ({
  children,
  handleFirstButton,
  handleSecondButton,
  textFirstButton,
  textSecondButton,
  disabledSecondButton,
}) => {
  const clientOrderFormApiStatus = useSelector(state => state.clientOrderForm?.apiStatus);

  return (
    <ApiContext.Consumer>
      {({ status }) => {
        const isWorking = status === 'WORKING' || clientOrderFormApiStatus === 'WORKING';

        return (
          <div className={classes.sticky}>
            <hr className={classes.hr} />

            <div className={classes.notification}>{children}</div>

            <span className="relative inline-block">
              <button
                type="button"
                className={[classes.Button, classes.secondary].join(' ')}
                onClick={handleFirstButton}
                disabled={isWorking}
                data-cy={String(textFirstButton).toLowerCase()}
              >
                <FormattedMessage id={textFirstButton} />
              </button>
            </span>

            <span className="relative inline-block">
              <button
                type="button"
                className={[classes.Button, classes.primary].join(' ')}
                onClick={handleSecondButton}
                disabled={isWorking || disabledSecondButton}
                data-cy={String(textSecondButton).toLowerCase()}
              >
                <FormattedMessage id={textSecondButton} />
              </button>

              {isWorking && <Spinner />}
            </span>
          </div>
        );
      }}
    </ApiContext.Consumer>
  );
};

OrderFormPageFooter.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  disabledSecondButton: PropTypes.bool,
  handleFirstButton: PropTypes.func.isRequired,
  handleSecondButton: PropTypes.func.isRequired,
  textFirstButton: PropTypes.string.isRequired,
  textSecondButton: PropTypes.string.isRequired,
};

OrderFormPageFooter.defaultProps = {
  children: null,
  disabledSecondButton: false,
};

export default OrderFormPageFooter;
